// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","close-button":"Modal_close-button__eyAXS","title":"Modal_title__3HkNf","content":"Modal_content__gGb69"};